import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { Icon } from '@iconify/vue';
export default {
  __name: 'MenuItem',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_icon, {
        size: "18"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Icon), {
          icon: `icon-park-outline:${__props.icon}`
        }, null, 8, ["icon"])]),
        _: 1
      }), _createElementVNode("span", null, _toDisplayString(__props.title), 1)], 64);
    };
  }
};